/**
 * @generated SignedSource<<689519894d2da1884d241a060fc84a35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteSkillCategoryInput = {
  id?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteSkillCategoryMutation$variables = {
  input: DeleteSkillCategoryInput;
};
export type deleteSkillCategoryMutation$data = {
  readonly deleteSkillCategory: {
    readonly deletedSkillCategoryId: string | null;
  } | null;
};
export type deleteSkillCategoryMutation = {
  variables: deleteSkillCategoryMutation$variables;
  response: deleteSkillCategoryMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteSkillCategoryPayload",
    "kind": "LinkedField",
    "name": "deleteSkillCategory",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedSkillCategoryId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteSkillCategoryMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteSkillCategoryMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e45baea2b77c7181e292176e220e8930",
    "id": null,
    "metadata": {},
    "name": "deleteSkillCategoryMutation",
    "operationKind": "mutation",
    "text": "mutation deleteSkillCategoryMutation(\n  $input: DeleteSkillCategoryInput!\n) {\n  deleteSkillCategory(input: $input) {\n    deletedSkillCategoryId\n  }\n}\n"
  }
};
})();

(node as any).hash = "661bfd5e8ef03cff76d2e99e67139224";

export default node;
